/**
 * Indian States and Major Cities
 * Used for location dropdown menus in user profiles
 */

export const INDIA_LOCATIONS = {
  'Andhra Pradesh': [
    'Visakhapatnam',
    'Vijayawada',
    'Guntur',
    'Nellore',
    'Tirupati',
    'Kakinada',
    'Rajahmundry',
    'Ongole',
    'Kurnool',
    'Hyderabad'
  ],
  'Arunachal Pradesh': [
    'Itanagar',
    'Naharlagun',
    'Pasighat',
    'Tezpur',
    'Ziro'
  ],
  'Assam': [
    'Guwahati',
    'Silchar',
    'Dibrugarh',
    'Nagaon',
    'Tinsukia',
    'Jorhat',
    'Barpeta',
    'Kamrup'
  ],
  'Bihar': [
    'Patna',
    'Gaya',
    'Bhagalpur',
    'Muzaffarpur',
    'Darbhanga',
    'Madhubani',
    'Purnia',
    'Nalanda'
  ],
  'Chhattisgarh': [
    'Raipur',
    'Bilaspur',
    'Durg',
    'Bhilai',
    'Rajnandgaon',
    'Raigarh',
    'Jagdalpur'
  ],
  'Goa': [
    'Panaji',
    'Vasco da Gama',
    'Margao',
    'Ponda',
    'Pernem',
    'Sanquelim'
  ],
  'Gujarat': [
    'Ahmedabad',
    'Surat',
    'Vadodara',
    'Rajkot',
    'Jamnagar',
    'Nadiad',
    'Anand',
    'Bhavnagar',
    'Dholan',
    'Gandhinagar'
  ],
  'Haryana': [
    'Faridabad',
    'Gurgaon',
    'Hisar',
    'Rohtak',
    'Panipat',
    'Yamunanagar',
    'Kaithal',
    'Karnal'
  ],
  'Himachal Pradesh': [
    'Shimla',
    'Solan',
    'Mandi',
    'Kangra',
    'Bilaspur',
    'Hamirpur',
    'Kullu',
    'Lahaul & Spiti'
  ],
  'Jharkhand': [
    'Ranchi',
    'Dhanbad',
    'Jamshedpur',
    'Giridih',
    'Deoghar',
    'Hazaribagh',
    'Dumka',
    'Bokaro'
  ],
  'Karnataka': [
    'Bangalore',
    'Mangalore',
    'Mysore',
    'Belgaum',
    'Hubli',
    'Davangere',
    'Hassan',
    'Kolar',
    'Tumkur',
    'Chitradurga'
  ],
  'Kerala': [
    'Kochi',
    'Thiruvananthapuram',
    'Kozhikode',
    'Ernakulam',
    'Thrissur',
    'Kottayam',
    'Pathanamthitta',
    'Idukki',
    'Wayanad',
    'Malappuram'
  ],
  'Madhya Pradesh': [
    'Bhopal',
    'Indore',
    'Jabalpur',
    'Gwalior',
    'Ujjain',
    'Sager',
    'Satna',
    'Rewa',
    'Chhindwara',
    'Khandwa'
  ],
  'Maharashtra': [
    'Mumbai',
    'Pune',
    'Nagpur',
    'Thane',
    'Kalyan',
    'Nashik',
    'Aurangabad',
    'Solapur',
    'Amravati',
    'Kolhapur'
  ],
  'Manipur': [
    'Imphal',
    'Imphal East',
    'Imphal West',
    'Bishnupur',
    'Thoubal'
  ],
  'Meghalaya': [
    'Shillong',
    'Tura',
    'Jowai',
    'Nongstoin',
    'Baghmara'
  ],
  'Mizoram': [
    'Aizawl',
    'Lunglei',
    'Saiha',
    'Champhai',
    'Kolasib'
  ],
  'Nagaland': [
    'Kohima',
    'Dimapur',
    'Mon',
    'Tuensang',
    'Wokha'
  ],
  'Odisha': [
    'Bhubaneswar',
    'Cuttack',
    'Rourkela',
    'Sambalpur',
    'Puri',
    'Balasore',
    'Dhenkanal',
    'Bargarh',
    'Angul'
  ],
  'Punjab': [
    'Chandigarh',
    'Ludhiana',
    'Amritsar',
    'Jalandhar',
    'Patiala',
    'Bathinda',
    'Hoshiarpur',
    'Phillaur',
    'Pathankot'
  ],
  'Rajasthan': [
    'Jaipur',
    'Jodhpur',
    'Kota',
    'Ajmer',
    'Udaipur',
    'Bikaner',
    'Alwar',
    'Barmer',
    'Chittorgarh',
    'Pali'
  ],
  'Sikkim': [
    'Gangtok',
    'Namchi',
    'Gyalshing',
    'Mangan',
    'Soreng'
  ],
  'Tamil Nadu': [
    'Chennai',
    'Coimbatore',
    'Madurai',
    'Salem',
    'Tiruppur',
    'Tiruchirappalli',
    'Kanyakumari',
    'Erode',
    'Tirunelveli',
    'Villupuram'
  ],
  'Telangana': [
    'Hyderabad',
    'Warangal',
    'Nizamabad',
    'Karimnagar',
    'Khammam',
    'Mahbubnagar',
    'Adilabad',
    'Medak'
  ],
  'Tripura': [
    'Agartala',
    'Udaipur',
    'Dharmanagar',
    'Ambassa',
    'Kailashahar'
  ],
  'Uttar Pradesh': [
    'Lucknow',
    'Kanpur',
    'Ghaziabad',
    'Noida',
    'Greater Noida',
    'Varanasi',
    'Meerut',
    'Agra',
    'Allahabad',
    'Rae Bareli',
    'Bareilly',
    'Mathura',
    'Saharanpur'
  ],
  'Uttarakhand': [
    'Dehradun',
    'Nainital',
    'Haridwar',
    'Rishikesh',
    'Rudrapur',
    'Almora',
    'Pithoragarh',
    'Bageshwar'
  ],
  'West Bengal': [
    'Kolkata',
    'Darjeeling',
    'Siliguri',
    'Asansol',
    'Durgapur',
    'Bardhaman',
    'Krishnanagar',
    'Jalpaiguri',
    'Cooch Behar'
  ]
};

export const STATES = Object.keys(INDIA_LOCATIONS).sort();

/**
 * Get cities for a specific state
 */
export const getCitiesForState = (state) => {
  return INDIA_LOCATIONS[state] || [];
};

/**
 * Update gallery size to 9 images max
 */
export const MAX_GALLERY_IMAGES = 9;

/**
 * Profile photo constraints
 */
export const PROFILE_PHOTO_CONSTRAINTS = {
  maxSize: 50 * 1024, // 50KB
  maxDimension: 800,
  types: ['image/jpeg', 'image/png', 'image/webp']
};

/**
 * Gallery photo constraints
 */
export const GALLERY_PHOTO_CONSTRAINTS = {
  maxSize: 50 * 1024, // 50KB per image
  maxDimension: 800,
  types: ['image/jpeg', 'image/png', 'image/webp'],
  maxCount: 9
};
